import { PageModuleDataToUpdate } from "entities/pages/types";
import { Timestamp, collection, doc, updateDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";

type Params = {
  moduleId: string;
  moduleData: PageModuleDataToUpdate;
  brandId: string;
  settingId: string;
};

export const updateSettingModule = async ({
  moduleData,
  moduleId,
  settingId,
  brandId,
}: Params): Promise<void> => {
  const collectionRef = collection(
    db,
    `brands/${brandId}/settings/${settingId}/modules`,
  );
  await updateDoc(doc(collectionRef, moduleId), {
    ...moduleData,
    updatedAt: Timestamp.now(),
  });
};
